export const CODE_VERIFIER_KEY = "code_verifier";
export const USER_DATA_KEY = "user_data";
export const JWT_TOKEN_KEY = "JWT_TOKEN";
